export { default } from './TermsPage';
